/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedAuctionActionCompletePurchase_item = {
    readonly isSold: boolean | null;
    readonly lastTransaction?: {
        readonly checkoutDate: string | null;
    } | null | undefined;
    readonly " $fragmentRefs": FragmentRefs<"useAuctionPricing_item" | "PdpSharedPurchaseButton_item">;
    readonly " $refType": "PdpSharedAuctionActionCompletePurchase_item";
};
export type PdpSharedAuctionActionCompletePurchase_item$data = PdpSharedAuctionActionCompletePurchase_item;
export type PdpSharedAuctionActionCompletePurchase_item$key = {
    readonly " $data"?: PdpSharedAuctionActionCompletePurchase_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedAuctionActionCompletePurchase_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionActionCompletePurchase_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            }
          ],
          "concreteType": "Transaction",
          "kind": "LinkedField",
          "name": "lastTransaction",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "checkoutDate",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useAuctionPricing_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPurchaseButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'b7b9427bec4a2db9a89a64b3b539e08d';
export default node;
